import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import {
  Note as NoteIcon,
  Comment as CommentIcon,
  AutoStories as MemoryIcon
} from '@mui/icons-material';
import type { ActivityType } from './useUnifiedActivity';

interface ActivityFiltersProps {
  filter: ActivityType;
  onChange: (filter: ActivityType) => void;
  personId: string;
}

export const ActivityFilters: React.FC<ActivityFiltersProps> = ({
  filter,
  onChange,
  personId
}) => {

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newFilter: ActivityType | null
  ) => {
    if (newFilter !== null) {
      onChange(newFilter);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <ToggleButtonGroup
        value={filter}
        exclusive
        onChange={handleChange}
        aria-label="activity filter"
        size="small"
        fullWidth
        sx={{
          '& .MuiToggleButton-root': {
            flex: 1
          }
        }}
      >
        <ToggleButton value="comment" aria-label="comments only">
          <CommentIcon sx={{ mr: 0.5, fontSize: '1.1rem' }} />
          Comments
        </ToggleButton>
        <ToggleButton value="note" aria-label="notes only">
          <NoteIcon sx={{ mr: 0.5, fontSize: '1.1rem' }} />
          Notes
        </ToggleButton>
        <ToggleButton value="memory" aria-label="memories only">
          <MemoryIcon sx={{ mr: 0.5, fontSize: '1.1rem' }} />
          Memories
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
